import React from "react";
import styled from "styled-components";

import { colors } from "../../design";
import { IUser } from "../../interfaces";
import Image from "../atoms/Image";
import Text from "../atoms/Text";

interface IProps {
  user: IUser;
  onClickUser: (user: IUser) => void;
}
const User: React.FC<IProps> = ({ user, onClickUser, ...props }) => (
  <>
    <OutWrapper onClick={() => onClickUser(user)}>
      <UserIcon {...props} src={user.pictureUrl} />
      <UserName>{user.displayName}</UserName>
    </OutWrapper>
  </>
);

const OutWrapper = styled.div`
  display: flex;
  padding: 8px 16px;
  cursor: pointer;
  align-items: center;
`;

const UserName = styled(Text)`
  line-height: 50px;
  padding: 0 16px;
  color: ${colors.darkGray};
`;

const UserIcon = styled(Image)`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

export default User;
